import './bootstrap';

import Alpine from 'alpinejs';
import Clipboard from "@ryangjchandler/alpine-clipboard"
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

window.Alpine = Alpine;
window.Chart = Chart;
window.ChartDataLabels = ChartDataLabels;

Alpine.plugin(Clipboard)
Alpine.start();

import.meta.glob([
    '../images/**',
    '../fonts/**',
    '../vendor/**/*.js',  // Handle any vendor JS files
    '../js/**',           // Handle any additional JS files in resources/js'
    '../css/**',
    '../pdf/**'
]);
